<template>
  <el-card shadow="hover" class="article_card">
    <el-row>
      <div style="font-size: 11.56px;
font-weight: 400;
letter-spacing: 0px;
line-height: 15.86px;
color: rgba(153, 153, 153, 1);">{{ article.publish_time || article.updateTime }}</div>
      <a href="javascript:void(0)">
        <div class="article_card_title" @click="openNewDetail">
          {{ article.title }}
        </div>
      </a>
    </el-row>
    <div style="clear:both;height:10px;"></div>

    <template v-if="articleType !== 'my'"> <el-col :span="12" class="article_card_time"> 来源：{{ article.source }}
      </el-col></template>

    <el-col :span="12" class="article_card_time" style="text-align:right;">
      <template v-if="article.summary && showDesc">
        <el-link :underline="false" @click="showSummary = !showSummary">
          <span style="font-size: 11.56px;
font-weight: 400;
color: rgba(75, 140, 247, 1);">
            <template v-if="showSummary">
              收起摘要
            </template>
            <template v-else>
              查看摘要
            </template>
          </span>
        </el-link>
      </template>
    </el-col>
    <template v-if="showSummary">
      <br><br>
      <span class="article_card_time" style="font-size: 12px;"> {{ article.summary }}</span>
      <el-col :span="24" class="article_card_time" style="text-align:right;">
        <el-link :underline="false" @click="insertToArticle">
          <span style="font-size: 11.56px;
font-weight: 400;
color: rgba(75, 140, 247, 1);">
            插入正文
          </span>
        </el-link>
      </el-col>
    </template>

    <div style="clear:both"></div>
  </el-card>
</template>

<script>
export default {
  name: 'articleExtentdCard',
  props: ['article', 'articleType', 'showDesc'],
  data () {
    return {
      extendContent: [],
      chooseTxt: '',
      showSummary: false
    }
  },
  methods: {
    openNewDetail () {
      this.$emit('openDetail', this.article)
    },
    insertToArticle () {
      this.$emit('insertToArticle')
    },

    clearCopyBtn () {
      var eles = document.getElementsByClassName('##chose##')
      for (var i = 0; i < eles.length; i++) {
        eles[i].remove()
      }
    },
    insertTxtToEdit () {
      var splitsLine = document.getElementsByClassName('@@@')
      if (splitsLine.length > 0) {
        splitsLine[0].before(this.chooseTxt)
        return
      }
      var articleEnd = document.getElementById('articleEditor')
      if (articleEnd) {
        articleEnd.after(this.chooseTxt)
      }
    },

    showChoseText (evnet) {
      this.clearCopyBtn()
      let txt
      if (window.getSelection) {
        var range = window.getSelection().getRangeAt(0)
        if (evnet.target.tagName === 'IMG') {
          this.insertTxtToEdit()
          this.clearCopyBtn()
          return
        }

        // 如果不是选中文本的状态
        if (range.endOffset !== range.startOffset) {
          txt = window.getSelection().baseNode.textContent.substring(range.startOffset, range.endOffset)

          var div = document.createElement('span')
          div.style.position = 'relative'
          div.style.width = '0px'
          div.style.height = '0px'
          div.style.top = '0'
          div.style.left = '0'
          div.style.zIndex = 9999
          div.className = '##chose##'

          let childDiv = document.createElement('a')
          childDiv.href = 'javascript:void(0)'
          childDiv.style.position = 'absolute'
          childDiv.style.width = '50px'
          childDiv.style.height = '20px'
          childDiv.style.top = '-20px'
          childDiv.style.left = '-50px'
          childDiv.innerHTML = '<img src="../assets/imgs/copyBtn.png" width="100%"/>'
          childDiv.style.zIndex = 99999
          div.appendChild(childDiv)
          range.insertNode(div)
          range.setStartAfter(div)
          // window.getSelection().removeRange(window.getSelection().getRangeAt(1))
        }
      } else {
        txt = document.selection.createRange().text
      }
      if (txt) {
        this.chooseTxt = txt
      }
    }
  }
}
</script>

<style lang="less" scoped>
.card_img {
  width: 30%;
}

.card_img img {
  width: 100%;
}

.article_card {
  width: 98%;
  text-align: left;
  border-radius: 5px;
  border: none;
  box-shadow: 0px 8px 10px 0px rgba(184, 184, 210, 0.2);
  margin: auto;
  margin-top: 10px;

  a {
    text-decoration: none;
  }

  .article_card_title {
    font-size: 0.9em;
    text-align: left;
    padding-top: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 96%;
    color: #555;
  }

  .el-card__body {
    position: relative;
    padding: 9px 0px !important;
    text-align: left;
  }
}

.article_card_time {
  display: inline-block;
  position: relative;
  font-size: 0.7em;
  color: rgba(153, 153, 153, 1);
  text-align: left;
}

.article_card_hot {
  display: inline-block;
  top: 17px;
  position: relative;
  left: 10px;
  font-size: 0.7em;
  color: #ccc;
  text-align: right;
}

.card_red {
  background: red;
  width: 55px;
  height: 38px;
  font-size: 5px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: -22px;
  top: -13px;
  text-align: center;
  padding-top: 22px;
  color: wheat;
}

.card_blue {
  background: blue;
  width: 55px;
  height: 38px;
  font-size: 5px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: -22px;
  top: -13px;
  text-align: center;
  padding-top: 22px;
  color: wheat;
}

.add_btn>.el-icon-plus {
  font-size: 80px;
  font-weight: 900;
  color: #ccc;
  text-align: center;
}

.add_text {
  text-align: center;
  margin-top: 20px;
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// src/components/article_extend_card.vue